export class AdminPageDefinition {
    constructor(public title = "", public icon = "", public routerLink: string[] = []) {
    }
}